<div class="full-bleed-row subscription-min-height">
    <div class="snap-eligibility-container">
        <div class="subscription-registration__logo-container fresh-pass__logo-container">
            <a href="{{logoUrl}}" aria-label="Freshpass logo">
                <img alt="{{ logoAltText }}" aria-hidden="true" class="fresh-pass__logo-container__logo-image" src="{{freshpassLogo}}">
            </a>
        </div>
        
        <div class="campaign-title-content">
            <span role="heading" aria-level="1" class="campaign-title-text">{{properties.planCard.campaignTitleText}}</span>
        </div>
        <div attr.aria-label="Qualifying SNAP EBT recipients can receive all the benefits of FreshPass monthly plan for just ${{snapMonthlyCharge}} a month instead of ${{regularMonthlyCharge}} a month.">
            <div class="campaign-text-content" aria-hidden="true">
                {{properties.planCard.freshpassBenefitDescription}} <span
                    class="snap-monthly-charge">${{snapAnnualPlanCharge}}</span>{{properties.planCard.planPerYear}}<span
                    class="snap-monthly-charge">${{snapMonthlyPlanCharge}}</span>{{properties.planCard.planPerMonth}}
                </div>
        </div>
        <div class="snap-cta-container">
            <div>
                <button (click)="goToAccountOrChoosePlan()" class="btn btn-lg btn-primary snap-eligible-button" [attr.aria-label]="isSnapVerified?'View My Plans':'See if I\'m Eligible'">{{isSnapVerified?"View My Plans":"Verify my eligibility"}}</button>
            </div>
            <div *ngIf="!isSnapVerified" class="links">
                <a (click)="goBack()" class="links__action underline body-text">Don't qualify? View our other plans.</a>
            </div>
        </div>
    </div>
</div>
